import { z } from 'zod'

// POST contact_request — reproduit le resolver postMessageAdmin
// (apollo/server/resolvers/Discussion/postMessageAdmin.ts).
// Le resolver mappait l'input MessageAdmin { subject, message } vers le body
// CS-Cart { name: subject, message }. On reproduit ce mapping cote hook.
export const postMessageAdminSchema = z.object({
  name: z.string(),
  message: z.string(),
})
export type PostMessageAdminInput = z.infer<typeof postMessageAdminSchema>
